export enum NotificationType {
    Discovery,
    Provision,
    Autoscaling,
    Failed
}
